import React from 'react'
import { Outlet } from 'react-router-dom'

export const WorkshopBase: React.FC = () => {
  return <Outlet />
}
